function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H1440V1024H0z",
  transform: "translate(-1010 -512)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6A7595",
  fillOpacity: 0.26,
  d: "M86 363h322v86.463L236 552 45 433l41-70z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7E8CB3",
  fillRule: "evenodd",
  d: "M245.783 484.735c0 8.253-8.516 14.948-19.011 14.948s-19.001-6.695-19.001-14.948c0-8.264 8.506-14.958 19.001-14.958 10.495 0 19.011 6.694 19.011 14.958zM116.073 409.192c0 8.263-8.507 14.957-19.001 14.957-10.495 0-19.002-6.694-19.002-14.957 0-8.254 8.507-14.948 19.002-14.948 10.494 0 19.001 6.694 19.001 14.948z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M338.665 345.903h6.887V119.729h-6.887v226.174z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M313.893 335.131h24.772V92.837h-24.772V335.13zM423.158 377.426L246.579 479.155v20.653l176.579-101.873v-20.509z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M246.579 479.155L70 377.426v20.47l176.579 101.912v-20.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M70 377.426l176.579 101.951 176.578-101.951-176.52-101.941L70 377.426z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M373.058 95.181v49.92l-92.785-53.553v-49.91l92.785 53.543z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M349.412 90.26v32.792L287.19 87.208v-32.86l62.222 35.912z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M383 89.552l-9.941 5.629v49.92l9.941-5.726V89.552z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M356.134 120.02v6.946l12.473 7.139v-6.878l-12.473-7.207zM356.134 107.174v6.956l12.473 7.13v-6.888l-12.473-7.198zM356.134 94.232v6.946l12.473 7.139v-6.878l-12.473-7.207z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M280.273 41.638L290.186 36 383 89.552l-9.942 5.629-92.785-53.543z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M291.816 61.43v7.527l51.252 29.605v-7.556L291.816 61.43z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M246.618 443.505l-.039-136.197 108.954-62.92v136.051l-108.915 63.066z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M246.619 443.505l-.039-136.197-108.964-62.92v136.051l109.003 63.066z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M137.616 244.388l108.964 62.92 108.954-62.92-108.915-62.891-109.003 62.891z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M315.028 307.395l-24.298 14.086v-39.748l24.298-14.095v39.757z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M315.027 267.638l-108.808-62.833-24.346 14.056 108.857 62.93 24.297-14.153z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M261.011 424.013v-6.994l36.576-21.196v7.11l-36.576 21.08zM261.011 411.497v-6.994l36.576-21.196v7.11l-36.576 21.08zM330.431 360.502v24.296l17.488-10.123v-24.296l-17.488 10.123zM161.583 357.954v25.314l-17.488-10.095V347.86l17.488 10.094zM185.453 371.788v25.314l-17.488-10.105v-25.303l17.488 10.094z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M180.051 283.961v36.377l-35.956-20.741v-36.425l35.956 20.789z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M175.636 291.401v-5.919l-28.283-16.294v5.832l28.283 16.381z",
  clipRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H1440V1024H0z",
  transform: "translate(-1010 -512)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  width: 481,
  height: 307,
  x: -14,
  y: 304,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 29.5
})));

function Svg404Image(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 512,
    fill: "none",
    viewBox: "0 0 430 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404image.9eb0833f.svg";
export { ForwardRef as ReactComponent };